import {useEffect} from "react";
import {batch, useSignal, signal} from "@preact/signals-react";
import {useAppToast} from "@ui-seeker/app";
import {postSubmit} from "@ui-seeker/utils";

import {commonFiltersValue, isLoadingCommonFilters, isSystemBusy} from "@signals";
import {WEBBACK_V2_API} from "@constants";
import {isEmpty, evolutionDataFilters, elementsInLoading, filterBrandTitle} from "../../../@signals"


export default function useShareOfSearchSharePercentageGraphData() {

	const { showToast } = useAppToast()

	const dataChart = useSignal([])
	const color = useSignal({})
	const series = useSignal([])
	const isLoading = useSignal(false)


    useEffect(() => {
		if (isLoadingCommonFilters.value) batch(() => {
			isLoading.value = true
			dataChart.value = []
			filterBrandTitle.value = ""
			postSubmit(`${WEBBACK_V2_API}/share-of-search/keyword-details/high-level`, { ...commonFiltersValue.value }).then(res => {
				if (!res.data.listData?.length)
					dataChart.value = []
				else
					dataChart.value = [...dataChart.value, res.data]
				
				color.value = res.color
				series.value = res.series
			}).catch(() => {
				isLoadingCommonFilters.value = false
				isSystemBusy.value = true
			}).finally(() => {
				isLoading.value = false
			})
		})
	}, [isLoadingCommonFilters.value]);

	useEffect(() => {
		if (isLoading.value)
			elementsInLoading.value = [...elementsInLoading.value, 'percentageChart']
		else
			elementsInLoading.value = elementsInLoading.value.filter(item => item !== 'percentageChart')
	}, [isLoading.value])


	return {
		dataChart: dataChart.value,
		color: color.value,
		series: series.value,
		isLoading: isLoading.value
	}
}